import { Box, styled } from '@mui/material';

export const StyledBox = styled(Box)(({ theme }) => ({
  width: '100%',
  backgroundColor: theme.palette.primary[50],
  borderRadius: '12px',
  padding: '16px 20px 16px 20px',
  position: 'relative',
}));

export const StyledTotalBox = styled(StyledBox)(({ theme }) => ({
  backgroundColor: theme.palette.grey[100],
}));
